export default function (context, val) {
    context.commit('set_tab', val);
}